import React from "react";
import { Button } from "@chakra-ui/react";

export const GoBackButton = ({ onClick, label = "Go back" }) => {
  return (
    <Button
      variant="ghost"
      color="primary.500"
      fontSize="14px"
      fontWeight={500}
      alignSelf="flex-start"
      px={0}
      h="auto"
      minH="auto"
      _hover={{ bg: "transparent", color: "primary.700" }}
      _active={{ bg: "transparent" }}
      onClick={onClick}
    >
      ← {label}
    </Button>
  );
};
